import React from "react";

import { personasActions } from '../actions';


import { connect } from 'react-redux'
import { PersonaDataCard } from '../components/PersonaDataCard';
import { Row, Col  } from "reactstrap";



var viewActions = require ('store/view.actions');

class NewPersona extends React.Component {

  componentDidMount() {
    
    this.props.setMainTitle("Alta de persona", [] )
  }

  constructor(props) {
    super(props);
    this.state = {
      modalOpen : false 
    }
 }

 setModalOpen = ( val ) => {
   this.setState( {modalOpen: val })
 }
 


//  handleInputChange = (event) => {
//   this.setState({ formData : { ...this.state.formData, [event.target.name]: event.target.value} });
// }


  render() {
    return (
      <>
            {/* <Modal toggle={() => this.setModalOpen(!this.state.modalOpen)} isOpen={this.state.modalOpen}  size="lg">
                <ModalBody >
                    <UploadImageCard  
                      persona={this.props.user} 
                      cancel={() => this.setModalOpen(!this.state.modalOpen)} 
                      isMyProfile={true}
                      updatePersona={this.props.updatePersona}
                    />
                </ModalBody>
            </Modal> */}


        <div className="content">
          <Row>
            <Col md="12">
                <PersonaDataCard 
                  token= {this.props.token}
                  // persona={this.props.user}
                  isNew={true}
                  createPersona={this.props.createPersona}
                  isSaving={this.props.view.loadingModules.savingPersonaDataCard}
                 />
            </Col>
            
          </Row>
        </div>
      </>
    );
  }
}

 const mapStateToProps = state => {
    return {
        token: state.auth.session.jwt_token,
        currentCalendarID:  state.school.currentCalendarID,
        user: state.auth.session.user,
        relatives: state.personas.relatives,
        view: state.view
     }
  }

  
  const mapDispatchToProps = dispatch => {
    return { 
        getRelatives: (token, personaID ) => {
          dispatch(personasActions.getRelatives(token, personaID ));
        },
        setMainTitle: ( title, menu ) => {
          dispatch(viewActions.setMainTitle( title, menu ))
        },
        createPersona: (token, data) => {
          dispatch(personasActions.createPersona(token , data ));
        }
        

 
    }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(NewPersona);

